import React, { useCallback, useEffect, useState } from 'react';
import { mapValues } from 'lodash';
import { AnchorRadioSelectProps } from 'src/components/AnchorRadioSelect/AnchorRadioSelect';
import './_AnchorDropdownSelect.scss';
import '../AnchorRadioSelect/_AnchorRadioSelect.scss';

import { MenuItem, Select, FormControl, InputLabel } from '@material-ui/core';

export default function AnchorDropdownSelect(props: AnchorRadioSelectProps) {
  const { anchor, onUpdateAnchorSelections, labelDimenion } = props;

  // shallow copy scope and set initialState default to first element of each key in object
  const initialState = mapValues(anchor, (ids) => [ids[0].id]);

  // filter any object that has array.length > 2
  const multiScopeKeys = Object.keys(anchor).filter((key) => anchor[key].length >= 2);
  const [selections, setSelections] = useState(initialState);

  useEffect(() => {
    // fire onChange on first render to set defaults as well as when selections change
    onUpdateAnchorSelections(selections);
  }, [onUpdateAnchorSelections, selections]);

  const handleOnChange = useCallback(
    (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
      const { name, value } = event.target;
      if (name) {
        const newSelections = { ...selections, [name]: [value as string] };
        setSelections(newSelections);
      }
    },
    [selections]
  );

  const checkboxes = multiScopeKeys.map((key) => {
    const dropdownOptions = anchor[key].map((anch) => {
      return {
        value: anch.id,
        text: anch[labelDimenion[key]],
        dimension: key,
      };
    });

    return (
      <div key={key} className="anchor-select">
        <div className="checkbox-group-label">{key.charAt(0).toUpperCase() + key.substring(1)}</div>

        <FormControl variant="outlined" fullWidth>
          <InputLabel>{`Select ${key}`}</InputLabel>
          <Select name={key} value={selections[key][0]} onChange={handleOnChange} label={`Select ${key}`}>
            {dropdownOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  });

  return <div className="checkbox-group">{checkboxes}</div>;
}
